function initializeSEGallery() {
  if (document.querySelector('[data-business-gallery]')) {
    document.querySelectorAll('.ebh-top-actions a[href^="#"], .ebh a[href="#eq-project"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        var header = document.querySelector('[data-section-type="header"]');
        var clearance = header ? Math.max(0, header.getBoundingClientRect().bottom) + 20 : (window.innerWidth <= 999 ? 110 : 210);
        window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - clearance), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, true);
    });
  }

  function patchBadge(badge) {
    if (!badge || badge.classList.contains('hc-jdgm-patched')) return;
    var textEl = badge.querySelector('.jdgm-prev-badge__text');
    if (!textEl) return;
    var count = textEl.dataset.numberOfReviews || badge.dataset.numberOfReviews;
    if (!count && textEl.textContent) {
      var match = textEl.textContent.match(/\d+/);
      if (match) count = match[0];
    }
    if (!count) return;
    textEl.textContent = '(' + count + ')';
    badge.classList.add('hc-jdgm-patched');
  }
  function patchAllBadges() {
    var badges = document.querySelectorAll('.jdgm-preview-badge');
    badges.forEach(patchBadge);
  }
  patchAllBadges();
  document.addEventListener('jdgm.loaded', patchAllBadges);
  var observer = new MutationObserver(function (mutations) {
    var shouldPatch = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.jdgm-preview-badge')) shouldPatch = true;
        else if (node.querySelector && node.querySelector('.jdgm-preview-badge')) shouldPatch = true;
      });
    });
    if (shouldPatch) patchAllBadges();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  initializeSEDesktopThumbs(document);
}
function initializeSEDesktopThumbs(root) {
    var mq = window.matchMedia('(min-width: 769px)');
    if (!mq.matches) return;
    var lists = Array.prototype.slice.call((root || document).querySelectorAll('.product-gallery--with-thumbnails .product-gallery__thumbnail-list'));
    function thumbCount(list) {
      return list ? list.querySelectorAll('.product-gallery__thumbnail').length : 0;
    }
    function shouldEnable(list) {
      return thumbCount(list) > 6;
    }
    function clamp(n, min, max) {
      return Math.max(min, Math.min(max, n));
    }
    lists.forEach(function (list) {
      if (list.closest('[data-elite-gallery]')) return;
      if (list.__seDesktopRefresh) { list.__seDesktopRefresh(); return; }
      var container = list.closest('.scroller__inner') || list.parentElement;
      if (!container) return;
      var enabled = shouldEnable(list);
      list.classList.toggle('hc-thumb-scroll-enabled', enabled);
      container.classList.toggle('hc-thumb-scroll-enabled', enabled);
      if (!enabled) return;
      if (!container.querySelector('.hc-thumb-scroll-btn--left')) {
        var btnLeft = document.createElement('button');
        btnLeft.type = 'button';
        btnLeft.className = 'hc-thumb-scroll-btn hc-thumb-scroll-btn--left';
        btnLeft.setAttribute('aria-label', 'Scroll thumbnails left');
        btnLeft.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path></svg>';
        var btnRight = document.createElement('button');
        btnRight.type = 'button';
        btnRight.className = 'hc-thumb-scroll-btn hc-thumb-scroll-btn--right';
        btnRight.setAttribute('aria-label', 'Scroll thumbnails right');
        btnRight.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.59 16.59 10 18l6-6-6-6-1.41 1.41L13.17 12z"></path></svg>';
        container.appendChild(btnLeft);
        container.appendChild(btnRight);
      }
      var btnL = container.querySelector('.hc-thumb-scroll-btn--left');
      var btnR = container.querySelector('.hc-thumb-scroll-btn--right');
      var bar = container.querySelector('.hc-thumbbar');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'hc-thumbbar';
        var thumb = document.createElement('div');
        thumb.className = 'hc-thumbbar__thumb';
        bar.appendChild(thumb);
        container.appendChild(bar);
      }
      var thumbEl = bar.querySelector('.hc-thumbbar__thumb');
      function sizes() {
        var trackW = bar.clientWidth;
        var scrollW = list.scrollWidth;
        var clientW = list.clientWidth;
        var ratio = clientW / scrollW;
        var thumbW = clamp(Math.round(trackW * ratio), 40, trackW);
        var maxThumbLeft = Math.max(0, trackW - thumbW);
        var maxScroll = Math.max(0, scrollW - clientW);
        return { trackW: trackW, scrollW: scrollW, clientW: clientW, ratio: ratio, thumbW: thumbW, maxThumbLeft: maxThumbLeft, maxScroll: maxScroll };
      }
      function syncThumb() {
        var s = sizes();
        thumbEl.style.width = s.thumbW + 'px';
        if (s.maxScroll <= 0) {
          thumbEl.style.left = '0px';
          if (btnL) btnL.hidden = true;
          if (btnR) btnR.hidden = true;
          bar.style.display = 'none';
          return;
        }
        bar.style.display = '';
        if (btnL) btnL.hidden = false;
        if (btnR) btnR.hidden = false;
        var pct = list.scrollLeft / s.maxScroll;
        var left = Math.round(s.maxThumbLeft * pct);
        thumbEl.style.left = left + 'px';
      }
      function step() {
        return Math.max(120, Math.floor(list.clientWidth * 0.8));
      }
      if (btnL) {
        btnL.addEventListener('click', function (e) {
          e.preventDefault();
          list.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (btnR) {
        btnR.addEventListener('click', function (e) {
          e.preventDefault();
          list.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
      var syncFrame = 0;
      function scheduleSyncThumb() {
        if (syncFrame) return;
        syncFrame = requestAnimationFrame(function () {
          syncFrame = 0;
          if (list.isConnected) syncThumb();
        });
      }
      list.__seDesktopRefresh = scheduleSyncThumb;
      list.addEventListener('load', scheduleSyncThumb, true);
      if (window.ResizeObserver) {
        var stripObserver = new ResizeObserver(scheduleSyncThumb);
        stripObserver.observe(list);
        stripObserver.observe(container);
        list.querySelectorAll('.product-gallery__thumbnail').forEach(function (item) { stripObserver.observe(item); });
      }
      list.addEventListener('scroll', scheduleSyncThumb, { passive: true });
      window.addEventListener('resize', scheduleSyncThumb, { passive: true });
      var listDragging = false;
      var listStartX = 0;
      var listStartScroll = 0;
      var listMoved = false;
      var dragEndAt = 0;
      list.addEventListener('pointerdown', function (e) {
        dragEndAt = 0;
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (!list || !list.scrollWidth || list.scrollWidth <= list.clientWidth) return;
        listDragging = true;
        listMoved = false;
        listStartX = e.clientX;
        listStartScroll = list.scrollLeft;
        list.classList.remove('se-dragging');
      });
      list.addEventListener('dragstart', function (e) { e.preventDefault(); });
      window.addEventListener('pointermove', function (e) {
        if (!listDragging) return;
        var dx = e.clientX - listStartX;
        if (!listMoved && Math.abs(dx) > 4) {
          listMoved = true;
          list.classList.add('se-dragging');
        }
        if (!listMoved) return;
        list.scrollLeft = listStartScroll - dx;
        e.preventDefault();
      }, { passive: false });
      window.addEventListener('pointerup', function () {
        if (!listDragging) return;
        listDragging = false;
        dragEndAt = listMoved ? Date.now() : 0;
        list.classList.remove('se-dragging');
      });
      list.addEventListener('click', function (e) {
        if (dragEndAt && (Date.now() - dragEndAt) < 250) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
      var dragging = false;
      var startX = 0;
      var startLeft = 0;
      thumbEl.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragging = true;
        thumbEl.classList.add('is-dragging');
        startX = e.clientX;
        startLeft = parseInt(thumbEl.style.left || '0', 10) || 0;
        e.preventDefault();
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var s = sizes();
        if (s.maxScroll <= 0) return;
        var dx = e.clientX - startX;
        var newLeft = clamp(startLeft + dx, 0, s.maxThumbLeft);
        var pct = s.maxThumbLeft ? (newLeft / s.maxThumbLeft) : 0;
        list.scrollLeft = Math.round(s.maxScroll * pct);
        e.preventDefault();
      }, { passive: false });
      window.addEventListener('pointerup', function () {
        if (!dragging) return;
        dragging = false;
        thumbEl.classList.remove('is-dragging');
      });
      window.addEventListener('pointercancel', function () {
        listDragging = false;
        dragging = false;
        list.classList.remove('se-dragging');
        thumbEl.classList.remove('is-dragging');
      });
      syncThumb();
    });
}
var seDesktopRefreshFrame = 0;
function scheduleSEDesktopThumbs() {
  if (seDesktopRefreshFrame) return;
  seDesktopRefreshFrame = requestAnimationFrame(function () {
    seDesktopRefreshFrame = 0;
    initializeSEDesktopThumbs(document);
  });
}
window.addEventListener('load', scheduleSEDesktopThumbs);
window.addEventListener('pageshow', scheduleSEDesktopThumbs);
window.addEventListener('resize', scheduleSEDesktopThumbs, { passive: true });
document.addEventListener('shopify:section:load', scheduleSEDesktopThumbs);
document.addEventListener('product:rerender', scheduleSEDesktopThumbs);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeSEGallery, { once: true });
else initializeSEGallery();
(function () {
  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function removeNodes(sel, root) { qsa(sel, root).forEach(function (n) { n.remove(); }); }
  function isMobile() { return window.innerWidth <= 768; }
  function getFlickityInstance(carouselEl) {
    if (!carouselEl) return null;
    if (carouselEl.flickity) return carouselEl.flickity;
    if (carouselEl._flickity) return carouselEl._flickity;
    try {
      if (window.Flickity && typeof window.Flickity.data === 'function') return window.Flickity.data(carouselEl);
    } catch (e) {}
    return null;
  }
  function stripFlickityDots(wrapper) {
    qsa('.flickity-page-dots', wrapper).forEach(function (n) { n.remove(); });
    var cw = qs('.product-gallery__carousel-wrapper', wrapper);
    if (cw) qsa('.flickity-page-dots', cw).forEach(function (n) { n.remove(); });
  }
  function getThumbScroller(wrapper) {
    var list = qs('.product-gallery__thumbnail-list', wrapper);
    if (!list) return null;
    return list.closest('.product-gallery__thumbnails') || list.closest('.scroller') || list.closest('.product-gallery__thumbnail-scroller') || list.parentElement;
  }
  function insertBetweenMainAndThumbs(wrapper, node) {
    var scroller = getThumbScroller(wrapper);
    if (scroller && scroller.parentNode) {
      scroller.parentNode.insertBefore(node, scroller);
      return true;
    }
    var list = qs('.product-gallery__thumbnail-list', wrapper);
    if (list && list.parentNode) {
      list.parentNode.insertBefore(node, list);
      return true;
    }
    wrapper.appendChild(node);
    return false;
  }
  function getSlides(wrapper) {
    var carousel = qs('.product-gallery__carousel', wrapper);
    if (!carousel) return [];
    var slides = qsa('.product-gallery__carousel-item', carousel);
    return slides.filter(function (el) { return el && el.nodeType === 1; });
  }
  function getSelectedIndexFromDom(slides) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList && slides[i].classList.contains('is-selected')) return i;
    }
    return 0;
  }
  function clickThumbForIndex(wrapper, slides, idx) {
    var slide = slides[idx];
    if (!slide) return false;
    var mediaId = slide.getAttribute('data-media-id');
    if (!mediaId) return false;
    var thumb = qs('.product-gallery__thumbnail[data-media-id="' + mediaId + '"]', wrapper);
    if (!thumb) return false;
    thumb.click();
    return true;
  }
  function clickStepToIndex(wrapper, slides, targetIdx) {
    var carouselWrapper = qs('.product-gallery__carousel-wrapper', wrapper) || wrapper;
    var btnPrev = qs('.flickity-prev-next-button.previous', carouselWrapper);
    var btnNext = qs('.flickity-prev-next-button.next', carouselWrapper);
    if (!btnPrev && !btnNext) return false;
    var guard = 0;
    function step() {
      var current = getSelectedIndexFromDom(slides);
      if (current === targetIdx) return;
      if (guard++ > 80) return;
      if (targetIdx > current) {
        if (btnNext && !btnNext.hasAttribute('disabled')) btnNext.click();
        else if (btnPrev) btnPrev.click();
      } else {
        if (btnPrev && !btnPrev.hasAttribute('disabled')) btnPrev.click();
        else if (btnNext) btnNext.click();
      }
      requestAnimationFrame(step);
    }
    step();
    return true;
  }
  function buildGallerySectionDots(wrapper) {
    if (!isMobile()) return;
    var carousel = qs('.product-gallery__carousel', wrapper);
    if (!carousel) return;
    var flkty = getFlickityInstance(carousel);
    var slides = getSlides(wrapper);
    var total = slides.length;
    if (flkty) {
      total = flkty.slides ? flkty.slides.length : (flkty.cells ? flkty.cells.length : total);
    }
    if (total < 2) {
      removeNodes('.se-gallery-dots', wrapper);
      return;
    }
    removeNodes('.se-gallery-dots', wrapper);
    var maxDots = 6;
    var dotsCount = Math.min(total, clamp(total, 3, maxDots));
    var lastSection = dotsCount - 1;
    var dots = document.createElement('div');
    dots.className = 'se-gallery-dots';
    var buttons = [];
    for (var i = 0; i < dotsCount; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'se-gallery-dot';
      if (wrapper.hasAttribute('data-business-gallery')) b.setAttribute('aria-label', wrapper.dataset.gallerySectionLabel + ' ' + (i + 1));
      (function (sectionIndex) {
        b.addEventListener('click', function () {
          var target = Math.floor((sectionIndex * total) / dotsCount);
          if (sectionIndex === lastSection) target = total - 1;
          target = clamp(target, 0, total - 1);
          var liveFlkty = getFlickityInstance(carousel);
          if (liveFlkty) {
            try { liveFlkty.select(target, true, true); } catch (e) {}
            return;
          }
          var freshSlides = getSlides(wrapper);
          if (!clickThumbForIndex(wrapper, freshSlides, target)) {
            clickStepToIndex(wrapper, freshSlides, target);
          }
        });
      })(i);
      dots.appendChild(b);
      buttons.push(b);
    }
    insertBetweenMainAndThumbs(wrapper, dots);
    function sectionIndexFromSlideIndex(slideIndex) {
      slideIndex = clamp(slideIndex || 0, 0, total - 1);
      if (total <= 1) return 0;
      var idx = Math.floor((slideIndex * dotsCount) / total);
      if (idx > lastSection) idx = lastSection;
      return idx;
    }
    function setActiveBySlideIndex(slideIndex) {
      var active = sectionIndexFromSlideIndex(slideIndex);
      for (var j = 0; j < buttons.length; j++) {
        if (j === active) buttons[j].classList.add('is-active');
        else buttons[j].classList.remove('is-active');
      }
    }
    function readSelectedIndex() {
      var liveFlkty = getFlickityInstance(carousel);
      if (liveFlkty) return liveFlkty.selectedIndex || 0;
      var freshSlides = getSlides(wrapper);
      return getSelectedIndexFromDom(freshSlides);
    }
    var thumbList = qs('.product-gallery__thumbnail-list', wrapper);
    function getThumbScrollTargets() {
      var targets = [];
      if (thumbList) targets.push(thumbList);
      if (thumbList && thumbList.parentElement) targets.push(thumbList.parentElement);
      if (thumbList) {
        var a = thumbList.closest('.scroller');
        var b = thumbList.closest('.scroller__inner');
        if (a) targets.push(a);
        if (b) targets.push(b);
      }
      var scroller = getThumbScroller(wrapper);
      if (scroller) targets.push(scroller);
      if (scroller && scroller.parentElement) targets.push(scroller.parentElement);
      var uniq = [];
      for (var i = 0; i < targets.length; i++) {
        var el = targets[i];
        if (!el) continue;
        if (uniq.indexOf(el) !== -1) continue;
        uniq.push(el);
      }
      return uniq;
    }
    function setActiveFromThumbScroll(el) {
      if (!el) return;
      var maxScroll = Math.max(0, el.scrollWidth - el.clientWidth);
      if (maxScroll <= 0) return;
      var s = el.scrollLeft || 0;
      var tol = 14;
      var pct;
      if (maxScroll - s <= tol) pct = 1;
      else if (s <= tol) pct = 0;
      else pct = s / maxScroll;
      var approxIndex = Math.round(pct * (total - 1));
      setActiveBySlideIndex(approxIndex);
      stripFlickityDots(wrapper);
    }
    function updateActive() {
      setActiveBySlideIndex(readSelectedIndex());
      stripFlickityDots(wrapper);
    }
    updateActive();
    wrapper.__hcUpdateActive = updateActive;
    wrapper.__hcSetActiveBySlideIndex = setActiveBySlideIndex;
    wrapper.__hcSetActiveFromThumbScroll = setActiveFromThumbScroll;
    if (wrapper.__hcGalleryBound) return;
    wrapper.__hcGalleryBound = true;
    var thumbScrollTargets = getThumbScrollTargets();
    if (thumbScrollTargets.length) {
      thumbScrollTargets.forEach(function (el) {
        el.addEventListener('scroll', function () {
          if (!isMobile()) return;
          if (wrapper.__hcSetActiveFromThumbScroll) wrapper.__hcSetActiveFromThumbScroll(el);
        }, { passive: true });
      });
      window.addEventListener('resize', function () {
        if (!isMobile()) return;
        setTimeout(function () {
          for (var i = 0; i < thumbScrollTargets.length; i++) {
            var el = thumbScrollTargets[i];
            if (!el) continue;
            if ((el.scrollWidth - el.clientWidth) > 0) {
              if (wrapper.__hcSetActiveFromThumbScroll) wrapper.__hcSetActiveFromThumbScroll(el);
              break;
            }
          }
        }, 0);
      }, { passive: true });
    }
    var activeFrame = null;
    var mo = new MutationObserver(function (mutations) {
      if (!mutations.some(function (m) { return m.target.matches && m.target.matches('.product-gallery__carousel-item'); })) return;
      if (activeFrame !== null) return;
      activeFrame = requestAnimationFrame(function () {
        activeFrame = null;
        if (wrapper.isConnected && wrapper.__hcUpdateActive) wrapper.__hcUpdateActive();
      });
    });
    mo.observe(carousel, { attributes: true, attributeFilter: ['class'], subtree: true });
    var attachTryCount = 0;
    function attachFlickityEventsWhenReady() {
      if (!isMobile()) return;
      var liveFlkty = getFlickityInstance(carousel);
      if (!liveFlkty) {
        attachTryCount++;
        if (attachTryCount < 60) setTimeout(attachFlickityEventsWhenReady, 150);
        return;
      }
      try {
        liveFlkty.on('change', function (index) {
          if (wrapper.__hcSetActiveBySlideIndex) wrapper.__hcSetActiveBySlideIndex(index);
          stripFlickityDots(wrapper);
        });
        liveFlkty.on('settle', function () {
          if (wrapper.__hcSetActiveBySlideIndex) wrapper.__hcSetActiveBySlideIndex(liveFlkty.selectedIndex || 0);
          stripFlickityDots(wrapper);
        });
      } catch (e) {}
      stripFlickityDots(wrapper);
      if (wrapper.__hcSetActiveBySlideIndex) wrapper.__hcSetActiveBySlideIndex(liveFlkty.selectedIndex || 0);
    }
    attachFlickityEventsWhenReady();
    var galleryWindowWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === galleryWindowWidth) return;
      galleryWindowWidth = window.innerWidth;
      removeNodes('.se-gallery-dots', wrapper);
      buildGallerySectionDots(wrapper);
    }, { passive: true });
  }
  function buildThumbSectionDots(wrapper) {
    if (!isMobile()) return;
    var list = qs('.product-gallery__thumbnail-list', wrapper);
    if (!list) return;
    if (!list.__seThumbLayoutBound) {
      list.__seThumbLayoutBound = true;
      var thumbLayoutFrame = 0;
      function refreshThumbLayout() {
        if (thumbLayoutFrame) return;
        thumbLayoutFrame = requestAnimationFrame(function () {
          thumbLayoutFrame = 0;
          if (wrapper.isConnected) buildThumbSectionDots(wrapper);
        });
      }
      list.addEventListener('load', refreshThumbLayout, true);
      if (window.ResizeObserver) {
        var thumbLayoutObserver = new ResizeObserver(refreshThumbLayout);
        thumbLayoutObserver.observe(list);
        list.querySelectorAll('.product-gallery__thumbnail').forEach(function (item) { thumbLayoutObserver.observe(item); });
      }
    }
    var maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
    var thumbSize = list.scrollWidth + ':' + list.clientWidth;
    if (list.__hcThumbSize === thumbSize) return;
    list.__hcThumbSize = thumbSize;
    if (maxScroll <= 0) {
      removeNodes('.se-thumb-dots', wrapper);
      return;
    }
    removeNodes('.se-thumb-dots', wrapper);
    var pages = Math.floor(maxScroll / Math.max(1, list.clientWidth));
    var pageCount = pages + 1;
    var dotsCount = clamp(pageCount, 2, 6);
    var dots = document.createElement('div');
    dots.className = 'se-thumb-dots';
    var buttons = [];
    for (var i = 0; i < dotsCount; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'se-thumb-dot';
      (function (dotIndex) {
        b.addEventListener('click', function () {
          var target = dotsCount === 1 ? 0 : Math.round((maxScroll * dotIndex) / (dotsCount - 1));
          list.scrollTo({ left: clamp(target, 0, maxScroll), behavior: 'smooth' });
        });
      })(i);
      dots.appendChild(b);
      buttons.push(b);
    }
    var scroller = getThumbScroller(wrapper);
    if (scroller && scroller.parentNode) scroller.parentNode.insertBefore(dots, scroller.nextSibling);
    else if (list.parentNode) list.parentNode.insertBefore(dots, list.nextSibling);
    else wrapper.appendChild(dots);
    function setActive(index) {
      index = clamp(index, 0, dotsCount - 1);
      for (var j = 0; j < buttons.length; j++) {
        if (j === index) buttons[j].classList.add('is-active');
        else buttons[j].classList.remove('is-active');
      }
    }
    function updateActiveByScroll() {
      var s = list.scrollLeft || 0;
      var tol = 14;
      if (maxScroll - s <= tol) {
        setActive(dotsCount - 1);
        return;
      }
      if (s <= tol) {
        setActive(0);
        return;
      }
      var pct = s / maxScroll;
      var active = Math.round(pct * (dotsCount - 1));
      setActive(active);
    }
    updateActiveByScroll();
    list.__hcUpdateActiveByScroll = updateActiveByScroll;
    if (!list.__hcThumbBound) {
      list.__hcThumbBound = true;
      list.addEventListener('scroll', function () {
        if (list.__hcUpdateActiveByScroll) list.__hcUpdateActiveByScroll();
      }, { passive: true });
      var thumbWindowWidth = window.innerWidth;
      window.addEventListener('resize', function () {
        if (window.innerWidth === thumbWindowWidth) return;
        thumbWindowWidth = window.innerWidth;
        buildThumbSectionDots(wrapper);
      }, { passive: true });
    }
  }
  function initWrapper(wrapper) {
    if (wrapper.hasAttribute('data-elite-gallery')) return;
    initializeSEDesktopThumbs(wrapper);
    buildGallerySectionDots(wrapper);
    buildThumbSectionDots(wrapper);
    if (isMobile() && qs('.se-gallery-dots', wrapper)) stripFlickityDots(wrapper);
  }
  function initAll() {
    qsa('.product-gallery').forEach(function (wrapper) { initWrapper(wrapper); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  window.addEventListener('load', initAll);
  window.addEventListener('pageshow', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('product:rerender', initAll);
  document.addEventListener('DOMContentLoaded', function () {
    var pendingGalleries = new Set();
    var galleryFrame = null;
    var galleryObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('.product-gallery')) pendingGalleries.add(node);
          node.querySelectorAll('.product-gallery').forEach(function (wrapper) { pendingGalleries.add(wrapper); });
        });
      });
      if (!pendingGalleries.size || galleryFrame !== null) return;
      galleryFrame = requestAnimationFrame(function () {
        galleryFrame = null;
        pendingGalleries.forEach(function (wrapper) { if (wrapper.isConnected) initWrapper(wrapper); });
        pendingGalleries.clear();
      });
    });
    galleryObserver.observe(document.body, { childList: true, subtree: true });
  });
})();






